import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

function KeywordsHitEvolution({ reviews, preview }: any) {

    // Safety check for reviews data
    if (!reviews || !Array.isArray(reviews) || reviews.length === 0) {
        return (
            <div className='p-0'>
                <div style={{ height: preview === true ? 70 : 100, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9CA3AF' }}>
                    No data available
                </div>
            </div>
        );
    }

    // Filter out reviews with null/undefined versions and ensure versions are strings
    const validReviews = reviews.filter((review: any) =>
        review && review.version !== null && review.version !== undefined && review.version !== ''
    );

    if (validReviews.length === 0) {
        return (
            <div className='p-0'>
                <div style={{ height: preview === true ? 70 : 100, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9CA3AF' }}>
                    No version data available
                </div>
            </div>
        );
    }

    // Get unique versions and ensure they're strings
    const uniqueVersions = [...new Set(validReviews.map((review: any) =>
        review.version ? review.version.toString() : 'Unknown'
    ))].filter(version => version !== 'Unknown');

    var graphData: any[] = []

    uniqueVersions.forEach((version: any) => {
        const count = validReviews.filter((r: any) => r.version && r.version.toString() === version).length;
        graphData.push(count);
    });

    const options: ApexOptions = {
        tooltip: {
            enabled: false
        },
        dataLabels: {
            enabled: false // Hides the data labels
        },
        chart: {
            type: "area",
            zoom: { enabled: false },
            toolbar: { show: false },
            animations: { enabled: false }
        },
        grid: {
            borderColor: "#E5E7EB",
            strokeDashArray: 3
        },
        stroke: { curve: 'smooth', width: 1 },
        xaxis: {
            categories: uniqueVersions,
            labels: {
                show: false
            },
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            }
        },
        yaxis: {
            labels: {
                show: false
            }
        }
    }

    var data = {
        series: [{
            name: "Hits",
            data: graphData
        }]
    };


    return (
        <div className='p-0'>
            <ReactApexChart
                options={options}
                series={data.series}
                type="area"
                height={preview === true ? 70 : 100} />
        </div>
    );
}

export default KeywordsHitEvolution;